<template>
  <div class="settings">
    <Breadcrumbs :items="breadcrumbs">
      <div class="csv-actions">
        <rp-button type="primary" @click="downloadCSV">Download CSV</rp-button>
        <rp-button type="primary" @click="openUpdateForm">Upload CSV </rp-button>
      </div>
    </Breadcrumbs>

    <rp-table
      name="iols"
      :results="getIolModels"
      noPagination
      :key="tableState"
      :headings="[{heading: 'Iol models', key: 'IOL'}, {heading: 'Updated at', key: 'date'}, {heading: 'Remove IOL', key: 'delete', button: true}]">
      <div
        v-for="(iol, index) in data"
        :key="index"
        :slot="'td-' + index + '-delete'">
        <span
          @click="deleteIol(iol)">
          <rp-sprite class="create-icon delete" name="delete"/>
        </span>
      </div>
    </rp-table>

    <rp-overlay :active="isUpdateFormOpen">
      <rp-iol-form
        @close="closeUpdate"
      />
    </rp-overlay>

    <rp-overlay :active="isConfirmDeleteOpen">
      <rp-alert
        class="error-icon"
        icon="raypro_icon"
        message="IOL Model deleted sucessfully"
        :onClick="closeConfirmWindow">
      </rp-alert>
    </rp-overlay>

    <!-- <rp-overlay :active="errorActive">
      <rp-alert
        class="error-icon"
        icon="warning_rounded"
        :message=deleteError
        :onClick="closeErrorWindow">
      </rp-alert>
    </rp-overlay> -->
  </div>
</template>

<script>
import page from '@/mixins/page'
import {mapGetters} from 'vuex'

import Overlay from 'raypro_ui/src/components/ui/Overlay'
import Breadcrumbs from '@/components/Breadcrumbs'
import Button from 'raypro_ui/src/components/ui/inputs/Button'
import Table from 'raypro_ui/src/components/ui/Table'
import Sprite from 'raypro_ui/src/components/ui/Sprite'
import IolForm from 'raypro_ui/src/components/ui/forms/IolCsvUpload'
import Alert from 'raypro_ui/src/components/ui/Alert'


import {getIolModels, getIolModelsCsv, deleteIolModel} from 'raypro_ui/src/api/iols'

export default {
  components: {
    'rp-button': Button,
    'rp-table': Table,
    'rp-overlay': Overlay,
    'rp-sprite': Sprite,
    'rp-iol-form': IolForm,
    'rp-alert': Alert,
    Breadcrumbs
  },

  mixins: [page],

  computed: {
    ...mapGetters([
      'authUser'
    ])
  },

  data() {
    return {
      title: 'Manage IOLs',
      breadcrumbs: [
        {label: 'Manage IOLs'}
      ],
      isUpdateFormOpen: false,
      isConfirmDeleteOpen: false,
      deleteError: '',
      errorActive: false,
      newLanguage: {
        name: '',
        code: '',
        file: null
      },
      data: {},
      tableState: 0,
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    }
  },

  methods: {
    openUpdateForm() {
      this.isUpdateFormOpen = true
    },

    closeConfirmWindow() {
      this.tableState++
      this.isConfirmDeleteOpen = false
    },

    closeErrorWindow() {
      this.deleteError = '',
      this.errorActive = false
    },

    downloadCSV() {
      const filename = 'IOL models.csv'

      getIolModelsCsv().then((res) => {
        const blob = new Blob([res.data], {type: 'text/csv'})
        const link = document.createElement('a')

        link.href = window.URL.createObjectURL(blob)
        link.download = filename
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
    },

    deleteIol(iol) {
      deleteIolModel(iol).then(() => {
        this.isConfirmDeleteOpen = true
      })
        .catch((err) => {
          // if(err.xhr.status === 422) {
          //   this.deleteError = `Operation iols ${err.response.errors.operation_iols}`
          //   this.errorActive = true
          // } else {
          //   this.deleteError = 'Something went wrong, please try again  '
          //   this.errorActive = true
          // }
        })
    },

    closeUpdate() {
      this.isUpdateFormOpen = false
      this.tableState++
    },

    getIolModels() {
      return getIolModels().then((res) => {
        const mapped = res.data.map((row) => {
          const date = new Date(row.updated_at)

          return {
            id: row.id,
            IOL: row.model,
            date: `${date.getDate()} ${this.months[date.getMonth()].toUpperCase()} ${date.getFullYear()}`
          }
        })

        this.data = mapped

        return {data: mapped}
      })
    }
  }
}
</script>

<style lang="sass" scoped>
  @import 'raypro_ui/src/styles/main.sass'
  @import '../../../stylesheets/helpers/mixins'

  .breadcrumbs
    .csv-actions
      display: flex
      flex-direction: row
      justify-content: flex-end

      button
        margin-right: 0
        margin-left: 15px

  .delete
    fill: $color-side-nav
</style>



// WEBPACK FOOTER //
// src/components/pages/Settings/ManageIols.vue